<template>
  <div class="logistics gray3">
    <div class="bg-white pad10 mar10-b flex items-center justify-between">
      <span>运单号：D201116043976</span>
      <span class="red">未起运</span>
    </div>
    <div class="bg-white pad10 mar10-b">
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">第三方订单号：</span>
        <span>D201116043976</span>
      </div>
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">货物信息：</span>
        <span>直营玉米（150公斤）</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="gray3">预约提货时间：</span>
        <span>2022.05.26 12:00:00</span>
      </div>
    </div>
    <div class="bg-white pad10 mar10-b">
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">发货人信息：</span>
      </div>
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">商城卖家</span>
        <span>1563763298</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="gray3">提货地址</span>
        <span>北京市海淀区中关村大厦</span>
      </div>
    </div>
    <div class="bg-white pad10 mar10-b">
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">收货人信息：</span>
      </div>
      <div class="flex items-center justify-between mar15-b">
        <span class="gray3">商城卖家</span>
        <span>1563763298</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="gray3">送货地址</span>
        <span>北京市海淀区中关村大厦</span>
      </div>
    </div>
    <div class="bg-white pad10 mar10-b flex items-center justify-between">
      <span>运单状态</span>
      <span>地图轨迹</span>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      orderInfo: {}
    };
  },
  created() {
    this.getHLOrderInfo();
  },
  methods: {
    getHLOrderInfo() {
      this.$store.dispatch("pickUp/getHLOrderInfo", {
        extServiceId: "2206061345270001"
      }).then((data) => {
        this.orderInfo = data || {};
      });
    }

  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
